module.exports = __webpack_public_path__ + "static/media/shego-lose.6a9898b1.png";